import { createAction } from '~reduxHelpers';

// Action types
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

// State
export const initialState = {
  isOpen: { profile: false, notifications: false },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TOGGLE_DRAWER:
      return {
        ...state,
        isOpen: {
          ...state.isOpen,
          [action.payload]: !state.isOpen[action.payload],
        },
      };
    default:
      return state;
  }
}

// Actions
export const toggleDrawer = createAction(TOGGLE_DRAWER);

// Selectors
export const getOpenStatus = state => state.drawer.isOpen;
